import type { Feature } from '@luna/gatekeeper';

export const upcomingInstallments: Feature = {
    enabled: false,
    _description: 'Display upcoming installments section on the transaction history page',
};
